module.exports = __webpack_public_path__ + "img/whatsapp.7abb8008.svg";